import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Selectorispogzpkkfxv as Selector } from './Selector.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { default1jaun537xukbl as default_0 } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Defaults.mjs';
import { get_displayNamehv5zo902rjy4 as get_displayName } from './Annotations.mjs';
import {
  Nothing_getInstance1x7nejv3dwhdr as Nothing_getInstance,
  Companion_instance16cifvdjsintt as Companion_instance,
  Companion_instance3bnzzufvyr983 as Companion_instance_0,
  Companion_instance3q5qrbb8dvim2 as Companion_instance_1,
  Companion_instance2xs5meuo4uk7b as Companion_instance_2,
  Companion_instance1iw39v478z3sa as Companion_instance_3,
  Companion_instance3okjoeswc063e as Companion_instance_4,
  Companion_instance3jp69gxf6v3e3 as Companion_instance_5,
  Companion_instance1oe56hdndwklm as Companion_instance_6,
  Companion_instanced9y0ghw4y3f4 as Companion_instance_7,
  Companion_instanceez0w06et8n0z as Companion_instance_8,
  Companion_instance288oh9kic3o9e as Companion_instance_9,
  Companion_instance1fe0vifomrwt0 as Companion_instance_10,
  Companion_instance2ca3a70e9t58s as Companion_instance_11,
  Companion_instancewuhi7j8dzj2n as Companion_instance_12,
  Companion_instancetqr20ikb6k9i as Companion_instance_13,
  Companion_instance1brivik930s8s as Companion_instance_14,
  Companion_instance1skqa9ankg6k1 as Companion_instance_15,
  Companion_instance2dt70m4k7qloa as Companion_instance_16,
  Companion_instance385iatw7zqcbc as Companion_instance_17,
  Companion_instance2gc3grqkqb8ba as Companion_instance_18,
  Companion_instanceh5qpv80ys58j as Companion_instance_19,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Modification.mjs';
import { NothingSerializer3oixyyf77l4xt as NothingSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ModificationSerializer36sautdazlmsc as ModificationSerializer } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ModificationSerialization.mjs';
import { first58ocm7j58k3q as first } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  get_centered31th09q7x90sf as get_centered,
  get_centeredVertically612wtasps5l3 as get_centeredVertically,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  Dimensions32ju1l7z4mh as Dimension,
  Companion_getInstance23x6zslwzj0st as Companion_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { sizeConstraints19w9rda6g3rqz as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  weight31wqab1913ly4 as weight,
  textPopover3tarprbgmgxbr as textPopover,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Frame.commonHtml.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { RenderContextxikz99gtpuie as RenderContext } from './RenderContext.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl1tl9xt9sj2eem as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfbq6gzmblx5q7v as TextView$_set_content_$ref_pketfb,
} from '../auth/EmailProofComponent.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { MySealedClassSerializerInterface1lg9fzm3qtbhk as MySealedClassSerializerInterface } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/MySealedClassSerializer.mjs';
import {
  LabelGapSemantic_getInstance2wftjv243mafi as LabelGapSemantic_getInstance,
  LabelSemantic_getInstance4iffxvo6ijig as LabelSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import { text189ciz0cnr32o as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { errorText83fzxqvlxz6i as errorText } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import {
  cellFormub3o1hqp20e5 as cellForm,
  Renderer1fhwti5gmwutm as Renderer,
} from './Renderer.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function registerModification(_this__u8e3s4) {
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'com.lightningkite.services.database.Modification'), ModificationRenderer_getInstance());
}
var ExtendedSubtypeDataClass;
function ExtendedSubtypeData() {
  if (ExtendedSubtypeDataClass === VOID) {
    class $ {
      constructor(serialName, niceName) {
        this.serialName_1 = serialName;
        this.niceName_1 = niceName;
      }
      toString() {
        return 'ExtendedSubtypeData(serialName=' + this.serialName_1 + ', niceName=' + this.niceName_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.serialName_1);
        result = imul(result, 31) + getStringHashCode(this.niceName_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ExtendedSubtypeData()))
          return false;
        if (!(this.serialName_1 === other.serialName_1))
          return false;
        if (!(this.niceName_1 === other.niceName_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ExtendedSubtypeData');
    ExtendedSubtypeDataClass = $;
  }
  return ExtendedSubtypeDataClass;
}
function ModificationRenderer$form$lambda$lambda(it) {
  return default_0(it.serializer_1);
}
function ModificationRenderer$form$lambda$lambda_0(it) {
  var tmp0_safe_receiver = ModificationRenderer_getInstance().get_extended_6mkb63_k$(it);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.niceName_1;
  return tmp1_elvis_lhs == null ? get_displayName(it.serializer_1) : tmp1_elvis_lhs;
}
function ModificationRenderer$form$lambda$lambda$lambda(it) {
  return it;
}
var ModificationRendererClass;
function ModificationRenderer() {
  if (ModificationRendererClass === VOID) {
    class $ {
      constructor() {
        ModificationRenderer_instance = this;
        this.name_1 = 'Fill In The Blank';
        this.matchesSerializer_1 = 'com.lightningkite.services.database.Modification';
        this.nothing_1 = new (ExtendedSubtypeData())(Nothing_getInstance().serializer_9w0wvi_k$().get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'no change');
        this.chain_1 = new (ExtendedSubtypeData())(Companion_instance.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'multiple');
        this.ifNotNull_1 = new (ExtendedSubtypeData())(Companion_instance_0.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'if present');
        this.assign_1 = new (ExtendedSubtypeData())(Companion_instance_1.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'set to');
        this.coerceAtMost_1 = new (ExtendedSubtypeData())(Companion_instance_2.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'cap at');
        this.coerceAtLeast_1 = new (ExtendedSubtypeData())(Companion_instance_3.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'floor at');
        this.increment_1 = new (ExtendedSubtypeData())(Companion_instance_4.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'add');
        this.multiply_1 = new (ExtendedSubtypeData())(Companion_instance_5.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'multiply by');
        this.appendString_1 = new (ExtendedSubtypeData())(Companion_instance_6.serializer_9w0wvi_k$().get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'append');
        this.appendRawString_1 = new (ExtendedSubtypeData())(Companion_instance_7.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'append');
        this.listAppend_1 = new (ExtendedSubtypeData())(Companion_instance_8.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'add items');
        this.listRemove_1 = new (ExtendedSubtypeData())(Companion_instance_9.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'remove where');
        this.listRemoveInstances_1 = new (ExtendedSubtypeData())(Companion_instance_10.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'remove items');
        this.listDropFirst_1 = new (ExtendedSubtypeData())(Companion_instance_11.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'drop first');
        this.listDropLast_1 = new (ExtendedSubtypeData())(Companion_instance_12.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'drop last');
        this.listPerElement_1 = new (ExtendedSubtypeData())('ListPerElement', 'for each');
        this.setAppend_1 = new (ExtendedSubtypeData())(Companion_instance_13.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'add items');
        this.setRemove_1 = new (ExtendedSubtypeData())(Companion_instance_14.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'remove where');
        this.setRemoveInstances_1 = new (ExtendedSubtypeData())(Companion_instance_15.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'remove items');
        this.setDropFirst_1 = new (ExtendedSubtypeData())(Companion_instance_16.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'drop first');
        this.setDropLast_1 = new (ExtendedSubtypeData())(Companion_instance_17.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'drop last');
        this.setPerElement_1 = new (ExtendedSubtypeData())('SetPerElement', 'for each');
        this.combine_1 = new (ExtendedSubtypeData())(Companion_instance_18.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'merge');
        this.removeKeys_1 = new (ExtendedSubtypeData())(Companion_instance_19.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'remove keys');
        var tmp = this;
        // Inline function 'kotlin.collections.associateBy' call
        var this_0 = listOf([this.nothing_1, this.chain_1, this.ifNotNull_1, this.assign_1, this.coerceAtMost_1, this.coerceAtLeast_1, this.increment_1, this.multiply_1, this.appendString_1, this.appendRawString_1, this.listAppend_1, this.listRemove_1, this.listRemoveInstances_1, this.listDropFirst_1, this.listDropLast_1, this.listPerElement_1, this.setAppend_1, this.setRemove_1, this.setRemoveInstances_1, this.setDropFirst_1, this.setDropLast_1, this.setPerElement_1, this.combine_1, this.removeKeys_1]);
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
        // Inline function 'kotlin.collections.associateByTo' call
        var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
        var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          var tmp$ret$2 = element.serialName_1;
          destination.put_4fpzoq_k$(tmp$ret$2, element);
        }
        tmp.all_1 = destination;
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_n14dum_k$(context, module_0) {
        return context.serializer_1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() === this.matchesSerializer_1 ? 1.0 : -1.0;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_n14dum_k$(context, module_0);
      }
      columnWidth_evxxme_k$(context, module_0) {
        return 20.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_evxxme_k$(context, module_0);
      }
      get_extended_6mkb63_k$(_this__u8e3s4) {
        return this.all_1.get_wei43m_k$(_this__u8e3s4.serializer_1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$());
      }
      form_vs3uiy_k$(context, value, module_0) {
        var tmp = context.serializer_1;
        var options = (tmp instanceof ModificationSerializer() ? tmp : THROW_CCE()).get_options_jecmyz_k$();
        return (_this__u8e3s4) => {
          var tmp = (it) => {
            // Inline function 'kotlin.collections.find' call
            var tmp0 = options;
            var tmp$ret$1;
            $l$block: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
              while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
                var element = _iterator__ex2g4s.next_20eer_k$();
                if (element.isInstance_1(it)) {
                  tmp$ret$1 = element;
                  break $l$block;
                }
              }
              tmp$ret$1 = null;
            }
            var tmp0_elvis_lhs = tmp$ret$1;
            return tmp0_elvis_lhs == null ? first(options) : tmp0_elvis_lhs;
          };
          var type = value.lens_drj4fu_k$(tmp, ModificationRenderer$form$lambda$lambda);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          var tmp_0 = get_centered(element);
          // Inline function 'kotlin.collections.maxOf' call
          var iterator = options.iterator_jk1svi_k$();
          if (!iterator.hasNext_bitz1p_k$())
            throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
          var it = iterator.next_20eer_k$();
          var tmp0_safe_receiver = ModificationRenderer_getInstance().get_extended_6mkb63_k$(it);
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.niceName_1;
          var maxValue = new (Dimension())(get_rem((tmp1_elvis_lhs == null ? get_displayName(it.serializer_1) : tmp1_elvis_lhs).length * 0.65));
          while (iterator.hasNext_bitz1p_k$()) {
            var it_0 = iterator.next_20eer_k$();
            var tmp0_safe_receiver_0 = ModificationRenderer_getInstance().get_extended_6mkb63_k$(it_0);
            var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.niceName_1;
            var v = new (Dimension())(get_rem((tmp1_elvis_lhs_0 == null ? get_displayName(it_0.serializer_1) : tmp1_elvis_lhs_0).length * 0.65));
            if (compareTo(maxValue, v) < 0) {
              maxValue = v;
            }
          }
          var tmp$ret$7 = maxValue.value_1;
          // Inline function 'com.lightningkite.kiteui.views.card' call
          var this_0 = sizeConstraints(tmp_0, VOID, VOID, VOID, VOID, VOID, tmp$ret$7);
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          var this_1 = themed(this_0, CardSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (Select())(this_1.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_1.willAddChild_hz2iwc_k$(element_0);
          var tmp_1 = _Constant___init__impl__v45mub(options);
          element_0.bind_64a41i_k$(type, new (Constant())(tmp_1), ModificationRenderer$form$lambda$lambda_0);
          element_0.onStartup_vrxh3i_k$();
          this_1.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          var this_2 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (Frame())(this_2.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_2.willAddChild_hz2iwc_k$(element_1);
          var $this$frame = element_1;
          reactive($this$frame, VOID, ($this$reactive) => {
            var selectedType = $this$reactive.invoke_r7m7el_k$(type);
            $this$frame.clearChildren_eufjq4_k$();
            var tmp = selectedType.serializer_1;
            var subSerializer = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
            var subContext = new (RenderContext())(isInterface(subSerializer, KSerializer()) ? subSerializer : THROW_CCE(), context.fieldAnnotations_1);
            var tmp_0 = (it) => selectedType.isInstance_1(it) ? it : default_0(subSerializer);
            var subValue = value.lens_drj4fu_k$(tmp_0, ModificationRenderer$form$lambda$lambda$lambda);
            module_0.form_gqhwsi_k$(subContext, subValue)(get_centeredVertically($this$frame));
            return Unit_instance;
          });
          element_1.onStartup_vrxh3i_k$();
          this_2.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_vs3uiy_k$(context, value, module_0);
      }
      view_96iqip_k$(context, value, module_0) {
        var tmp = context.serializer_1;
        var options = (tmp instanceof ModificationSerializer() ? tmp : THROW_CCE()).get_options_jecmyz_k$();
        return (_this__u8e3s4) => {
          var type = lens(value, (it) => {
            // Inline function 'kotlin.collections.find' call
            var tmp0 = options;
            var tmp$ret$1;
            $l$block: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
              while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
                var element = _iterator__ex2g4s.next_20eer_k$();
                if (element.isInstance_1(it)) {
                  tmp$ret$1 = element;
                  break $l$block;
                }
              }
              tmp$ret$1 = null;
            }
            var tmp0_elvis_lhs = tmp$ret$1;
            return tmp0_elvis_lhs == null ? first(options) : tmp0_elvis_lhs;
          });
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          element.set_gap_jwjroq_k$(get_rem(0.25));
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          var this_0 = get_centered(element);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (TextView())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_0.willAddChild_hz2iwc_k$(element_0);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
          element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            var tmp0_safe_receiver = ModificationRenderer_getInstance().get_extended_6mkb63_k$($this$invoke.invoke_r7m7el_k$(type));
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.niceName_1;
            return tmp1_elvis_lhs == null ? get_displayName($this$invoke.invoke_r7m7el_k$(type).serializer_1) : tmp1_elvis_lhs;
          });
          element_0.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          var this_1 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (Frame())(this_1.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_1.willAddChild_hz2iwc_k$(element_1);
          var $this$frame = element_1;
          reactive($this$frame, VOID, ($this$reactive) => {
            var selectedType = $this$reactive.invoke_r7m7el_k$(type);
            $this$frame.clearChildren_eufjq4_k$();
            var tmp = selectedType.serializer_1;
            var subSerializer = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
            var subContext = new (RenderContext())(isInterface(subSerializer, KSerializer()) ? subSerializer : THROW_CCE(), context.fieldAnnotations_1);
            var subValue = lens(value, (it) => selectedType.isInstance_1(it) ? it : default_0(subSerializer));
            module_0.view_ntgxjz_k$(subContext, subValue)(get_centeredVertically($this$frame));
            return Unit_instance;
          });
          element_1.onStartup_vrxh3i_k$();
          this_1.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_96iqip_k$(context, value, module_0);
      }
      cellView_bcuz5v_k$(context, value, module_0) {
        var tmp = context.serializer_1;
        var serializer = isInterface(tmp, MySealedClassSerializerInterface()) ? tmp : THROW_CCE();
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => toString($this$invoke.invoke_r7m7el_k$(value)));
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      cellView_2dvin1_k$(context, value, module_0) {
        return this.cellView_bcuz5v_k$(context, value, module_0);
      }
      labeledForm_k3j06c_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          var tmp2 = label;
          // Inline function 'com.lightningkite.kiteui.forms.fieldWithoutBorder' call
          var description_0 = description;
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(LabelGapSemantic_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.set_vertical_nuap32_k$(false);
          element_0.set_gap_jwjroq_k$(get_rem(0.25));
          text(themed(get_centered(element_0), LabelSemantic_getInstance()), tmp2);
          if (!(description_0 == null)) {
            var tmp0 = textPopover(get_centered(element_0), description_0);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance().info_1.resize_q1xpz0_k$(get_rem_0(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (IconView())(tmp0.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            tmp0.willAddChild_hz2iwc_k$(element_1);
            element_1.set_source_3o5lkf_k$(icon);
            element_1.set_description_s1386w_k$('Info');
            element_1.onStartup_vrxh3i_k$();
            tmp0.addChild_2qpft2_k$(element_1);
          }
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          ModificationRenderer_getInstance().form_vs3uiy_k$(context, value, module_0)(element);
          errorText(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledForm_ughtr2_k$(context, value, module_0, label, description) {
        return this.labeledForm_k3j06c_k$(context, value, module_0, label, description);
      }
      labeledView_biti61_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          var tmp2 = label;
          // Inline function 'com.lightningkite.kiteui.forms.fieldWithoutBorder' call
          var description_0 = description;
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(LabelGapSemantic_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.set_vertical_nuap32_k$(false);
          element_0.set_gap_jwjroq_k$(get_rem(0.25));
          text(themed(get_centered(element_0), LabelSemantic_getInstance()), tmp2);
          if (!(description_0 == null)) {
            var tmp0 = textPopover(get_centered(element_0), description_0);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance().info_1.resize_q1xpz0_k$(get_rem_0(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (IconView())(tmp0.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            tmp0.willAddChild_hz2iwc_k$(element_1);
            element_1.set_source_3o5lkf_k$(icon);
            element_1.set_description_s1386w_k$('Info');
            element_1.onStartup_vrxh3i_k$();
            tmp0.addChild_2qpft2_k$(element_1);
          }
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          ModificationRenderer_getInstance().view_96iqip_k$(context, value, module_0)(element);
          errorText(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledView_aldyvt_k$(context, value, module_0, label, description) {
        return this.labeledView_biti61_k$(context, value, module_0, label, description);
      }
    }
    protoOf($).cellForm_4mayde_k$ = cellForm;
    initMetadataForObject($, 'ModificationRenderer', VOID, VOID, [Renderer()]);
    ModificationRendererClass = $;
  }
  return ModificationRendererClass;
}
var ModificationRenderer_instance;
function ModificationRenderer_getInstance() {
  if (ModificationRenderer_instance === VOID)
    new (ModificationRenderer())();
  return ModificationRenderer_instance;
}
//region block: exports
export {
  registerModification as registerModification41dip2d4pqgm,
};
//endregion

//# sourceMappingURL=ModificationRenderer.mjs.map
